import gql from 'graphql-tag';

export default gql`
  query getMovieList(
    $id: String!
    $page: Int
    $filter: String
    $userUtcOffset: String
  ) {
    movieList(
      id: $id
      page: $page
      filter: $filter
      userUtcOffset: $userUtcOffset
    ) {
      id
      filter
      items {
        id
        directors {
          name
        }
        poster
        displayReleaseDate {
          date
        }
        title
        runtime
      }
      page
      pageCount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/queries/getMovieList.ts